module.exports = __webpack_public_path__ + "static/img/solution1.f389bea.png";


//////////////////
// WEBPACK FOOTER
// ./static/officeImg/index/solution1.png
// module id = 0RNq
// module chunks = 1